import { getBaseUrl } from 'js/constants/api';

export const getFastApiBaseUrl = (endpoint, requestMethod) => getBaseUrl(endpoint, requestMethod);
